import Swiper from 'swiper/bundle';

jQuery(document).ready(function ($) {
    // Header mobile menu: aria-expanded + .is-nav-open on header (no :has — Safari-safe)
    $('header .nav-toggle').on('click', function () {
        var $btn = $(this);
        var $header = $btn.closest('header');
        var open = $btn.attr('aria-expanded') === 'true';
        var nextOpen = !open;
        $btn.attr('aria-expanded', nextOpen ? 'true' : 'false');
        $header.toggleClass('is-nav-open', nextOpen);
    });

    // Post grid category filter (matches .module-post-grid: .inner > .grid-filters + .card-grid)
    $('.module-post-grid .grid-filter').on('click', function () {
        var $btn = $(this);
        var filter = String($btn.attr('data-filter') || '');
        var $grid = $btn.closest('.inner').find('.card-grid');
        var $cards = $grid.find('.card');

        $btn.closest('.grid-filters').find('.grid-filter').removeClass('is-active');
        $btn.addClass('is-active');

        if (filter === 'all') {
            $cards.show();
        } else {
            $cards.each(function () {
                var categories = $(this).data('category') || '';
                var match = categories.split(/\s+/).indexOf(filter) !== -1;
                $(this).toggle(match);
            });
        }
    });

    // Helper: main / outer Swiper (pagination & nav scoped to this instance, not nested children)
    function initSwiper($swiperElement, options) {
        if ( options === void 0 ) options = {};

        var swiperSettings = $swiperElement.data('swiper') || {};
        var config = Object.assign({}, swiperSettings,
            {loop: false},
            options);
        var $pagination = $swiperElement.children('.swiper-pagination');
        if ($pagination.length) {
            config.pagination = {
                el: $pagination[0],
                clickable: true,
            };
        }
        var $next = $swiperElement.siblings('.swiper-button-next');
        var $prev = $swiperElement.siblings('.swiper-button-prev');
        if ($next.length && $prev.length) {
            config.navigation = {
                nextEl: $next[0],
                prevEl: $prev[0],
            };
        }
        return new Swiper($swiperElement[0], config);
    }

    function initTimelineTabs($module, swiper) {
        var $buttons = $module.find('.swiper-tab-button');
        var $select = $module.find('.swiper-tabs-select');
        if (!$buttons.length && !$select.length) {
            return;
        }

        function setActive(index) {
            if ($buttons.length) {
                $buttons.removeClass('is-active').attr('aria-selected', 'false');
                var $btn = $buttons.eq(index);
                if ($btn.length) {
                    $btn.addClass('is-active').attr('aria-selected', 'true');
                }
            }
            if ($select.length) {
                $select.val(String(index));
            }
        }

        $buttons.each(function (index) {
            $(this).on('click', function () {
                swiper.slideTo(index);
            });
        });

        if ($select.length) {
            $select.on('change', function () {
                var idx = parseInt($(this).val(), 10);
                if (!Number.isNaN(idx)) {
                    swiper.slideTo(idx);
                }
            });
        }

        swiper.on('slideChange', function () {
            setActive(swiper.activeIndex);
        });

        setActive(swiper.activeIndex);
    }

    if ($('.swiper-default').length > 0) {
        $('.swiper-default').each(function () {
            var $el = $(this);
            var swiper = initSwiper($el);
            var $timeline = $el.closest('.module-timeline');
            if ($timeline.length && swiper) {
                initTimelineTabs($timeline, swiper);
            }
        });
    }

    if ($('.swiper-nested').length > 0) {
        $('.swiper-nested').each(function () {
            initSwiper($(this));
        });
    }
});
